import { gsap } from "gsap";

const _cardProdotto = (() => {
    const init = (): void => {
        const mmDesktopString = "(min-width: 992px)";
        const mmMobileString = "(max-width: 991px)";

        const mm = gsap.matchMedia();

        document.querySelectorAll(".card-prodotto").forEach((el) => {
            el = el.children[0];
            const imgContainer = el.querySelector(".media-container") as HTMLElement | null;
            const innerImg = imgContainer?.querySelector("img") as HTMLImageElement | null;

            if (!imgContainer) return;

            mm.add(mmDesktopString, () => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: "top top",
                        end: "+=500",
                        scrub: true,
                        pin: el,
                    },
                });

                tl.from(imgContainer, {
                    scale: 0.5,
                    ease: "power2.in",
                });

                // if (innerImg) {
                //     tl.from(
                //         innerImg,
                //         {
                //             scale: 1.1,
                //             ease: "none",
                //         },
                //         "<",
                //     );
                // }
            });

            mm.add(mmMobileString, () => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: "top top",
                        end: "+=500",
                        scrub: true,
                        pin: el,
                    },
                });

                tl.from(imgContainer, {
                    scale: 0.5,
                    ease: "power2.in",
                });

                // if (innerImg) {
                //     tl.from(
                //         innerImg,
                //         {
                //             scale: 1.1,
                //             ease: "none",
                //         },
                //         "<",
                //     );
                // }
            });
        });
    };

    return {
        init: init,
    };
})();

export default _cardProdotto;
